<template>
  <v-layout
      row
      align-center
  >
    <v-flex
        class="pa-2 ma-1"
    >
      <v-card class="ma-1">
        <v-card-title
            v-if="services.length > 0 && !selectedService"
            class="justify-center"
            style="word-break: break-word"
        >Please Select A Service
        </v-card-title>
        <div v-else>
          <v-card-title
              v-if="selectedService"
              class="justify-center"
              style="word-break: break-word"
          >{{ selectedService.name }}
          </v-card-title>
          <v-card-title
              class="justify-center"
              style="word-break: break-word"
          >Please Select An Appointment Date
          </v-card-title>
        </div>
        <v-snackbar
            v-model="error"
            color="error"
            :timeout="5000"
            top
        >
          {{ error_msg }}
        </v-snackbar>
        <div
            v-if="this.services.length > 0"
        >
          <div
              v-if="!selectedService"
              class="pa-1"
          >
            <div
                style="text-align: center"
            >
              <v-btn
                  :class="btnFontClass"
                  class="col-5 ma-4"
                  v-for="(service, index) in services"
                  :key="index"
                  x-large
                  :color="btnColor"
                  :style="btnTextSize(service)"
                  @click="selectService(service)"
              >
                {{ service.name }}
              </v-btn>
            </div>
          </div>
          <div v-if="selectedService">
            <v-row justify="center" class="ma-1">
              <v-col
                  cols="12"
                  lg="6"
                  md="12"
                  sm="12"
              >
                <v-date-picker
                    v-model="serviceDate"
                    :allowed-dates="serviceAllowedDates"
                    class="mt-4 ml-1"
                    :min="serviceMinDate"
                    @click:date="setServicesTimes()"
                    full-width
                ></v-date-picker>
              </v-col>
              <v-col
                  cols="12"
                  lg="6"
                  md="12"
                  sm="12"
              >
                <v-row class="mt-5 ml-1">
                  <v-col
                      cols="12"
                  >
                    <v-label>Earliest Time</v-label>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col
                      cols="12"
                  >
                    <div class="col pt-0 ma-1">
                      <v-btn
                          block
                          color="primary"
                          class="white--text"
                          @click="openDialog2"
                      >
                        <v-layout
                            row
                            align-center
                        >
                          <v-flex
                              xs8
                              class="text-left"
                              :style="timeslotTextSize()"
                          >
                            <span>{{ serviceSelectedTime }} ({{ selectedServiceTimeRemain }} available)</span>
                          </v-flex>
                          <v-flex
                              xs4
                              class="text-right"
                              style="font-size: 12px;font-weight: bolder; font-style: italic"
                          >
                            <span>CHANGE</span>
                          </v-flex>
                        </v-layout>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col
                      cols="12"
                  >
                    <v-text-field
                        v-if="queue.allow_pax_input"
                        v-model="pax"
                        label="Pax"
                        outlined
                        class="col ma-2"
                        autocomplete="off"
                        type="number"
                        min="1"
                        :rules="[paxRules]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col
                      cols="12"
                  >
                    <div class="col ma-1">
                      <v-btn
                          block
                          color="primary"
                          class="white--text"
                          @click="validate('s')"
                          :disabled="isLoading"
                      >Submit
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-dialog
                v-model="timesDialog2"
                scrollable
                max-width="310px"
            >
              <v-card class="grey-color">
                <v-card-title>Select a time</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-radio-group
                      v-model="serviceSelectedTime"
                      v-if="serviceTimes && serviceTimes.length > 0"
                      column
                      class="mt-0"
                      @change="changeRemain()"
                  >
                    <v-radio
                        v-for="(t,index) in serviceTimes"
                        :key="index"
                        :label="t.time + '('+ t.remain + ' available)'"
                        :value="t.time"
                    />
                  </v-radio-group>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                      block
                      text
                      color="primary"
                      @click="timesDialog2 = false"
                  >Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
        <div
            v-else
        >
          <v-row justify="center" class="ma-1">
            <v-col
                cols="12"
            >
                <div class="col-sm-6 mx-auto">
                  <v-date-picker
                      v-model="date"
                      :allowed-dates="allowedDates"
                      class="mt-4 ml-1"
                      :min="minDate"
                      @click:date="setTimes()"
                      full-width
                  ></v-date-picker>
                </div>
            </v-col>
            <v-col
                cols="12"
            >
                <div class="col-sm-6 mx-auto">
                  <v-row class="mt-5 ml-1" justify="center">
                    <v-col
                        cols="12"
                    >
                      <v-label>Please select time</v-label>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                        cols="12"
                    >
                      <div class="col pt-0 ma-1">
                        <v-btn
                            block
                            color="primary"
                            class="white--text"
                            @click="openDialog"
                        >
                          <v-layout
                              row
                              align-center
                          >
                            <v-flex
                                xs8
                                class="text-left"
                                :style="timeslotTextSize()"
                            >
                              <span>{{ selectedTime }} ({{ selectedTimeRemain }} available)</span>
                            </v-flex>
                            <v-flex
                                xs4
                                class="text-right"
                                style="font-size: 12px;font-weight: bolder; font-style: italic"
                            >
                              <span>CHANGE</span>
                            </v-flex>
                          </v-layout>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="ml-1" v-if="queue.allow_pax_input">
                    <v-col
                        cols="12"
                    >
                      <v-label>Pax</v-label>
                      <v-radio-group v-model="pax" row>
                        <v-radio
                            v-for="n in pax_limit_radio"
                            :key="n"
                            :label="`${n}`"
                            :value="n"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                        cols="12"
                    >
                      <div class="col ma-1">
                        <v-btn
                            block
                            color="primary"
                            class="white--text"
                            @click="validate('q')"
                            :disabled="isLoading"
                        >Submit
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
            </v-col>
          </v-row>
          <v-dialog
              v-model="timesDialog"
              scrollable
              max-width="310px"
          >
            <v-card class="grey-color">
              <v-card-title>Select a time</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-radio-group
                    v-model="selectedTime"
                    v-if="times && times.length > 0"
                    column
                    class="mt-0"
                    @change="changeRemain()"
                >
                  <v-radio
                      v-for="(t,index) in times"
                      :key="index"
                      :label="t.time + ' ('+ t.remain + ' available)'"
                      :value="t.time"
                  />
                </v-radio-group>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                    block
                    text
                    color="primary"
                    @click="timesDialog = false"
                >Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <v-dialog
            v-model="particularDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
          <v-card class="grey-color">
            <v-card-title>Fill in your particular</v-card-title>
            <v-card-subtitle>Information received is for contacting purposes, we will not use it for
              marketing
            </v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <v-row
                  justify="center"
              >
                <v-text-field
                    label="Name"
                    v-model="guest_name"
                    class="col ma-2"
                    autocomplete="off"
                    required
                >
                </v-text-field>
              </v-row>
              <v-row
                  justify="center"
              >
                <vue-tel-input
                    v-model="guest_phone"
                    name="phone"
                    defaultCountry="SG"
                    :onlyCountries="['SG', 'MY', 'CN', 'HK']"
                    required
                    :maxLen="15"
                    enabledCountryCode
                    validCharactersOnly
                    :wrapperClasses="['mobile-input']"
                    @validate="validateMobile"
                    @open="openMobile"
                    class="col ma-2"
                    autocomplete="off"
                ></vue-tel-input>
              </v-row>
              <v-row
                  v-if="guest_phone.length > 0 && !mobileIsValid"
                  justify="center"
                  style="margin-top: -18px; margin-bottom: 5px;"
              >
                <v-flex class="col-6 ml-1">
                  <span style="font-size: 10px; color: red">Your mobile number is invalid</span>
                </v-flex>
              </v-row>
              <v-row
                  justify="center"
              >
                <v-text-field
                    label="Email"
                    v-model="guest_email"
                    class="col ma-2"
                    autocomplete="off"
                    type="email"
                >
                </v-text-field>
              </v-row>
            </v-card-text>
            <v-card-actions
                class="justify-center"
            >
              <v-btn
                  rounded
                  class="pl-8 pr-8"
                  @click="particularDialog = false"
              >back
              </v-btn>
              <v-btn
                  rounded
                  color="primary"
                  class="pl-8 pr-8"
                  :disabled="isLoading"
                  @click="sendConfirm()"
              >Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="otpDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
          <v-card class="grey-color">
            <v-card-subtitle>Please enter the 6-digit OTP in below box.</v-card-subtitle>
            <v-card-subtitle>Mobile Number: xxxx {{ lastFourDigit(guest_phone) }}</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <v-row
                  justify="center"
              >
                <v-text-field
                    v-model="otpConfirm"
                    outlined
                    class="col-sm-6"
                    autocomplete="off"
                >
                  <v-card-text
                      class="pa-0"
                      slot="prepend"
                  >
                    OTP:
                  </v-card-text>
                  <v-btn
                      slot="append-outer"
                      color="red"
                      tile
                      class="white--text mt-0"
                      @click="sendOTP()"
                  >
                    Resend OTP
                  </v-btn>
                </v-text-field>
              </v-row>
              <v-row>
                <v-card-text
                    class="text-center"
                >
                  If you do not received the SMS OTP, please click "Resend OTP".
                </v-card-text>
              </v-row>
            </v-card-text>
            <v-card-actions
                class="justify-center"
            >
              <v-btn
                  class="white--text"
                  tile
                  color="red"
                  @click="checkOTP()"
              >Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="bookDoneDialog"
        >
          <v-card class="grey-color">
            <v-row
                justify="center"
            >
              <v-icon
                  x-large
                  class="ma-4"
              >mdi-thumb-up
              </v-icon>
            </v-row>
            <v-card-title class="justify-center">Thanks for booking!</v-card-title>
            <v-card-subtitle class="text-center">You booked an appointment with {{ outlet.name }} on <span
                style="font-weight: bold"> {{ appointmentTime }}</span></v-card-subtitle>
            <v-row
                justify="center"
            >
              <v-btn
                  class="white--text mt-2 mb-2 signup"
                  rounded
                  color="primary"
                  @click="refresh()"
              >Close
              </v-btn>
            </v-row>
          </v-card>
        </v-dialog>

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'queue-admin',
  data: () => {
    return {
      minDate: '',
      date: '',
      times: [],
      serviceMinDate: '',
      serviceDate: '',
      serviceTimes: [],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"],
      selectedDate: null,
      selectedTime: null,
      serviceSelectedDate: null,
      serviceSelectedTime: null,
      availability: [],
      dow: [],
      serviceDow: [],
      timesDialog: false,
      timesDialog2: false,
      pax: 1,
      error: false,
      error_msg: '',
      particularDialog: false,
      guest_name: '',
      guest_email: '',
      guest_phone: '',
      internationalPhone: '',
      mobileIsValid: false,
      countryCodes: [
        {'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore'},
        {'flag': '🇨🇳', 'country_code': 86, 'name': 'China'},
        {'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China'},
        {'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia'},
      ],
      otpDialog: false,
      otpConfirm: '',
      otp: '',
      bookDoneDialog: false,
      qlist_id: '',
      selectedService: null,
      isLoading: null,
      selectedTimeRemain: '',
      pax_limit_radio: 0,
      breadcrumbsItems: '',
      breadcrumbsItems2: '',
      selectedServiceTimeRemain: '',
      appointmentTime: '',
    }
  },
  computed: {
    btnColor() {
      return this.outlet.main_color ? this.outlet.main_color : 'black';
    },
    btnFontClass() {
      let c = this.outlet.main_font_color ? this.outlet.main_font_color : 'white';
      return c + '--text'
    },
  },
  props: ['outlet', 'queue', 'user', 'operation_times', 'operation_dow', 'services'],
  methods: {
    btnTextSize(q) {
      let size = 'small';
      if (q.name.length > 20 && q.name.length < 30) size = 'small';
      if (q.name.length > 30) size = 'x-small';
      return {
        fontSize: size,
        fontWeight: 'bold',
      }
    },
    timeslotTextSize() {
      if (window.innerWidth < 500) {
        return {
          fontSize: '12px',
        }
      } else {
        return '';
      }
    },
    lastFourDigit(num) {
      return num.substr(num, -4);
    },
    async book(model) {
      // submit
      this.isLoading = true;
      let date, time;
      let error = null;
      let phone = '';
      if (model === 'q') {
        date = this.date;
        time = this.selectedTime;
      } else {
        date = this.serviceDate;
        time = this.serviceSelectedTime;
      }
      if (time.includes(':')) {
        let t = time.split(' ');
        time = t[0];
      }

      await axios.post('/outlet/' + this.outlet.id + '/queue/addToQueue/' + this.queue.id, {
        user: this.user,
        guest_name: this.guest_name,
        guest_phone: this.internationalPhone,
        guest_email: this.guest_email,
        queue_id: this.queue.id,
        service_id: this.selectedService ? this.selectedService.id : null,
        appointment_date: date + ' ' + time,
        pax: this.pax,
      }).then(response => {
        error = response.data.error_msg ? response.data.error_msg : null;
        phone = response.data.phone_no ? response.data.phone_no : this.internationalPhone;
        // pop out booking done
        this.qlist_id = response.data.id;
        this.otpDialog = false;
      });

      if (error) {
        this.isLoading = false;
        this.error = true;
        this.error_msg = error;
      } else {
        await axios.post('/api/sendConfirm', {
          phone: phone,
          outlet_name: this.outlet.name,
          qlist_id: this.qlist_id,
        });
        this.appointmentTime = this.serviceSelectedTime ? this.serviceSelectedTime : this.selectedTime;
        this.isLoading = false;
        this.bookDoneDialog = true;
      }
    },
    validate(model) {
      let v_time, v_date;
      let v_user = true;
      if (model === 'q') {
        // check date and time
        v_time = !!this.selectedTime;
        v_date = !!this.date;
      } else {
        // service check date and time
        v_time = !!this.serviceSelectedTime;
        v_date = !!this.serviceDate;
      }
      // check user/guest
      if (this.user === 'guest') v_user = false;

      if (v_time && v_date && v_user) {
        this.book(model);
      } else {
        if (!v_time) {
          this.error = true;
          this.error_msg = 'Time is not valid.'
        }
        if (!v_date) {
          this.error = true;
          this.error_msg = 'Date is not valid.'
        }
        if ((v_date && v_time) && !v_user) {
          this.particularDialog = true;
        }
      }

    },
    allowedDates(val) {
      let day = new Date(val).getDay();
      let dayOfWeekCheck = false;
      //check day of week
      this.dow.forEach(function (o) {
        if (o.includes(day)) {
          dayOfWeekCheck = true;
        }
      });
      //check blackout date
      return dayOfWeekCheck;
    },
    serviceAllowedDates(val) {
      let day = new Date(val).getDay();
      let dayOfWeekCheck = false;
      //check day of week
      this.serviceDow.forEach(function (o) {
        if (o.includes(day)) {
          dayOfWeekCheck = true;
        }
      });
      //check blackout date
      return dayOfWeekCheck;
    },
    openDialog() {
      this.setTimes();
      this.timesDialog = !this.timesDialog
    },
    openDialog2() {
      this.setServicesTimes();
      this.timesDialog2 = !this.timesDialog2
    },
    setTimes() {
      let limit = this.queue.pax_limit;
      axios.post('/api/operation_times/getQueueTimeslotByDate', {
        qid: this.queue.id,
        date: this.date
      }).then(response => {
        this.times = response.data;
        this.selectedTime = response.data[0].time;
        this.selectedTimeRemain = response.data[0].remain;
        this.pax_limit_radio = limit > response.data[0].remain ? response.data[0].remain : limit;
      });
      // axios.get('/api/operation_times/model?qid='+ this.queue.id+'&date='+this.date)
      //     .then(response => {
      //         if (response.data){
      //             this.times = response.data;
      //             this.selectedTime = response.data[0].time;
      //         }
      //     });
    },
    setServicesTimes() {
      let limit = this.queue.pax_limit;
      axios.post('/api/operation_times/getQueueTimeslotByDate', {
        qid: this.queue.id,
        date: this.serviceDate,
        sid: this.selectedService.id
      }).then(response => {
        this.selectedServiceTimeRemain = response.data[0].remain;
        this.serviceTimes = response.data;
        this.serviceSelectedTime = response.data[0].time;
        this.pax_limit_radio = limit > response.data[0].remain ? response.data[0].remain : limit;
      });
      // axios.get('/api/operation_times/model?sid='+ this.selectedService.id+'&date='+this.serviceDate)
      //     .then(response => {
      //         if (response.data){
      //             this.serviceTimes = response.data;
      //             this.serviceSelectedTime = response.data[0].time;
      //         }
      //     });
    },
    paxRules(v) {
      let limit = this.queue.pax_limit ? this.queue.pax_limit : this.queue.limit
      if (v <= limit && v > 0) {
        return true
      } else {
        return 'Over Limit!'
      }
    },
    validateMobile(phoneObject) {
          this.mobileIsValid = phoneObject.valid;
          this.country_code = phoneObject.country_code;
          if (phoneObject.valid && phoneObject.nationalNumber) {
              this.internationalPhone = phoneObject.country.dialCode + phoneObject.nationalNumber
          }
    },
    openMobile() {
      // Manually set using JS because CSS isn't applying the style
      const dropdownElementStyle = document.getElementsByClassName('vti__dropdown')[0].childNodes[2].style;
      if (dropdownElementStyle) {
        dropdownElementStyle.fontSize = "14px";
        dropdownElementStyle.width = "250px";
      }
    },
    sendConfirm() {
      this.isLoading = true;
      if (!this.guest_phone) {
        this.isLoading = false;
        this.error = true;
        this.error_msg = 'Mobile number is required!';
        return false;
      } else {
        if (!this.guest_name) {
          this.isLoading = false;
          this.error = true;
          this.error_msg = 'Name is required!';
          return false;
        } else {
          if (this.selectedService) {
            this.book('s');
          } else {
            this.book('q');
          }
        }
      }
    },
    sendOTP() {
      if (!this.guest_phone) {
        this.error = true;
        this.error_msg = 'Mobile number is required!';
        return false;
      } else {
        if (!this.guest_name) {
          this.error = true;
          this.error_msg = 'Name is required!';
          return false;
        } else {
          axios.post('/api/sendOTP', {
            phone: this.internationalPhone,
            outlet_name: this.outlet.name,
            msg: 'Please use this OTP to confirm your Booking.',
          }).then(response => {
            this.particularDialog = false;
            this.otp = response.data;
            this.otpDialog = true;
          });
        }
      }
    },
    checkOTP() {
      if (this.otp && this.otpConfirm) {
        console.log(this.otp, this.otpConfirm);
        if (this.otp === parseInt(this.otpConfirm)) {
          this.book();
        } else {
          this.error = true;
          this.error_msg = 'Invalid OTP.';
        }
      } else {
        if (!this.otp) {
          this.error = true;
          this.error_msg = 'OTP does not set properly. Please contact developer.';
        }
        if (!this.otpConfirm) {
          this.error = true;
          this.error_msg = 'OTP is needed.'
        }
      }
    },
    checkBooking() {
      if (this.user !== 'guest') {
        // go to my booking page
        this.bookDoneDialog = false;
        window.location.href = '/outlet/' + this.outlet.id + '/my_booking'
      } else {
        // go to register page
        window.location.href = '/register?gid=' + this.outlet.group_id + '&oid=' + this.outlet.id + '&qlist_id=' + this.qlist_id
      }
    },
    home() {
      window.location.href = '/outlet/' + this.outlet.id
    },
    selectService(s) {
      let q = this.queue;
      let newDate = new Date();
      let year = newDate.getFullYear();
      let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
      let day = (newDate.getDate() < 10) ? '0' + newDate.getDate() : newDate.getDate();
      //set today
      this.serviceMinDate = year + '-' + month + '-' + day;
      axios.get('/api/operation_times/getServiceDayOfWeek?qid=' + q.id + '&sid=' + s.id).then(response => {
        this.selectedService = s;
        this.serviceDow = Object.values(response.data);
      });
    },
    changeRemain() {
      let t = this.selectedTime;
      let remain = '';
      let limit = '';
      this.times.forEach(function (item, index) {
        if (item.time === t) {
          remain = item.remain;
          limit = item.limit;
        }
      });
      this.selectedTimeRemain = remain;
      this.pax_limit_radio = this.queue.pax_limit > remain ? remain : this.queue.pax_limit;
    },
    refresh() {
      window.location.reload();
    }
  },
  beforeMount() {
    let newDate = new Date();
    let year = newDate.getFullYear();
    let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
    let day = (newDate.getDate() < 10) ? '0' + newDate.getDate() : newDate.getDate();
    let today = year + '-' + month + '-' + day;
    this.minDate = today;
    this.date = today;
    this.serviceDate = today;
    this.setTimes();
    this.dow = Object.values(this.operation_dow);
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/QueueAppointment.vue